export const getDateANumberOfDaysFromNow = (numberOfDays: number): Date => {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), today.getDate() + numberOfDays);
};

export const getNumberOfDaysForMonth = (month: number): number => {
    if (month === 1) return 31;
    if (month === 2) return 28;
    if (month === 3) return 31;
    if (month === 4) return 30;
    if (month === 5) return 31;
    if (month === 6) return 30;
    if (month === 7) return 31;
    if (month === 8) return 31;
    if (month === 9) return 30;
    if (month === 10) return 31;
    if (month === 11) return 30;
    if (month === 12) return 31;
    return 31;
};

export const getDayTranslationKeyFromDayNumber = (day: number): string => {
    if (day === 0) return 'sunday';
    if (day === 1) return 'monday';
    if (day === 2) return 'tuesday';
    if (day === 3) return 'wednesday';
    if (day === 4) return 'thursday';
    if (day === 5) return 'friday';
    if (day === 6) return 'saturday';
    return 'monday'
}
